import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { EMPTY, catchError, retry, throwError, timer } from 'rxjs';

const RETRY_COUNT = 2;
const RETRY_DELAY_MS = 2000;
const GRAPH_PHOTO_URL = 'https://graph.microsoft.com/v1.0/me/photo/$value';
export const SKIP_RETRY_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  const isGraphPhotoApi = req.url.startsWith(GRAPH_PHOTO_URL);
  const skipRetryInterceptor = req.context.get(SKIP_RETRY_INTERCEPTOR);

  return next(req).pipe(
    retry({
      count: RETRY_COUNT,
      delay: (error: unknown) => {
        if (skipRetryInterceptor) {
          return throwError(() => error);
        }

        if (isGraphPhotoApi) {
          return throwError(() => error);
        }

        if (error instanceof HttpErrorResponse && (error.status === 408 || error.status === 504)) {
          return timer(RETRY_DELAY_MS);
        }

        return throwError(() => error);
      },
    }),
    catchError((error: unknown) => {
      if (isGraphPhotoApi) {
        return EMPTY;
      }

      return throwError(() => error);
    }),
  );
};
